import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { toast } from "react-toastify";
import Header from "./Header";
import SideBar from "./SideBar";
import ForcedPasswordChangeModal from "./ForcedPasswordChangeModal";
import BaseApi from "../../Http/BaseApi";
import { passwordReminderMessage } from "../../Utils/passwordPolicy";

const Layout = () => {
  const { user } = useSelector((state) => state.auth);
  const [forceChange, setForceChange] = useState(
    Boolean(user?.password_force_change)
  );

  useEffect(() => {
    let cancelled = false;

    const applyStatus = (status) => {
      if (!status || cancelled) return;

      setForceChange(Boolean(status.password_force_change));

      try {
        const stored = JSON.parse(localStorage.getItem("userData") || "null");
        if (stored?.user) {
          stored.user = { ...stored.user, ...status };
          localStorage.setItem("userData", JSON.stringify(stored));
        }
      } catch (_) {
        /* ignore */
      }

      if (status.password_force_change) return;

      const days = Number(status.password_days_remaining);
      if (status.password_warn && days >= 0 && days <= 7) {
        const key = `pwd_warn_${days}`;
        if (!sessionStorage.getItem(key)) {
          sessionStorage.setItem(key, "1");
          toast.warn(passwordReminderMessage(days), {
            position: "top-right",
            autoClose: 8000,
            hideProgressBar: false,
            closeOnClick: true,
          });
        }
      }
    };

    // Always refresh from API so force/warn stays accurate after policy/SQL updates.
    BaseApi()
      .get("password-status")
      .then((res) => applyStatus(res.data))
      .catch(() => {
        if (user?.password_force_change) {
          setForceChange(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [user]);

  return (
    <>
      <div className='min-h-ful'>
        <Header />

        <main className='flex w-full h-screen'>
          <SideBar />
          <section className='w-full p-2'>
            <Outlet />
          </section>
        </main>
      </div>
      {forceChange && <ForcedPasswordChangeModal />}
    </>
  );
};

export default Layout;
